<div
    class="flex flex-col md:flex-row items-center md:items-start bg-gray-100 dark:bg-gray-900 p-6 sm:p-10 rounded-2xl mx-auto w-full max-w-6xl gap-6 md:gap-0 border border-gray-300 dark:border-gray-700 shadow-lg">
    <!-- Sidebar Esquerda -->
    <div class="w-full md:w-1/3 flex flex-col items-center space-y-6">
        <ui-photo [id]="userId ?? 1" *ngIf="avatar" [size]="EComponentSize.Large" [isCircular]="true" [editable]="false"
            [imageUrl]="avatar.path" (click)="openImage(avatar.path)"
            class="cursor-pointer hover:scale-105 transition-transform duration-300">
        </ui-photo>

        <div class="w-full sm:w-auto">
            <ui-label [tag]="ELabelTypes.TITLE" [clickable]="false" [type]="EAlert.DARK">
                {{ user?.name ?? 'Nome do usuário' }}
            </ui-label>
            <ui-label [tag]="ELabelTypes.PARAGRAPH" [clickable]="false" [type]="EAlert.DARK">
                {{ user?.birthDate ? (user?.birthDate! | relativeDate) : 'Data de nascimento não preenchida.' }}
            </ui-label>
        </div>


        <hr class="border-gray-300 dark:border-gray-700 w-full my-4">

        <div class="w-full mt-4 space-y-2">
            <ui-circular-progress [size]="EComponentSize.Medium" *ngIf="profileComplete" [percentage]="profileComplete"
                [color]="EAlert.DANGER" [icon]="EIcon.User" [clickable]="false">
            </ui-circular-progress>
        </div>
    </div>

    <!-- Conteúdo Direita -->
    <div class="w-full md:w-2/3 flex flex-col px-6 space-y-6">

        <!-- Nome e Data de Nascimento -->
        <div
            class="flex flex-col sm:flex-row justify-between items-center w-full gap-4 sm:gap-8 text-center sm:text-left">
            <ui-button *ngIf="userId != currentUser?.sub" [icon]="EIcon.Chat" [size]="EComponentSize.Small"
                [type]="EAlert.DARK" text="Iniciar conversa" (action)="addContact()"
                class="w-full sm:w-auto mt-4 sm:mt-0 sm:ml-auto sm:mr-0 text-center">
            </ui-button>
            <ui-button *ngIf="userId === currentUser?.sub" [size]="EComponentSize.Small" [type]="EAlert.DARK"
                text="Editar perfil" (action)="editProfile()"
                class="w-full sm:w-auto mt-4 sm:mt-0 sm:ml-auto sm:mr-0 text-center">
            </ui-button>

        </div>

        <!-- Navegação das Tabs -->
        <div class="flex gap-8 justify-start w-full">
            <ui-label [tag]="ELabelTypes.PARAGRAPH" [type]="currentTab === 'info' ? EAlert.INFO : EAlert.DARK"
                (click)="changeTab('info')" class="cursor-pointer px-4 py-2 text-lg font-semibold">
                Informações Pessoais
            </ui-label>
            <ui-label [tag]="ELabelTypes.PARAGRAPH" [type]="currentTab === 'photos' ? EAlert.INFO : EAlert.DARK"
                (click)="changeTab('photos')" class="cursor-pointer px-4 py-2 text-lg font-semibold">
                Fotos
            </ui-label>
        </div>

        <!-- Conteúdo das Tabs -->
        <div class="relative overflow-hidden w-full">
            <div class="flex transition-transform duration-300 ease-in-out w-full min-w-full flex-nowrap"
                [ngStyle]="{ transform: currentTab === 'info' ? 'translateX(0)' : 'translateX(-102%)' }">

                <!-- Informações Pessoais -->
                <div class="w-[101%] flex-shrink-0 rounded-xl shadow-lg  transition-all duration-300">
                    <ui-dynamic-form [withBorder]="false" [useSteps]="false" [inList]="false"
                        [finalSubmit]="'Atualizar'" [showButtons]="false" [fields]="currentFields">
                    </ui-dynamic-form>
                </div>

                <div class="w-[100%] flex-shrink-0 p-6 rounded-xl shadow-lg border border-gray-300 dark:border-gray-700
                bg-white dark:bg-gray-800 transition-all duration-300">
                    <div *ngIf="files.length > 0; else emptyState"
                        class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div *ngFor="let file of files" class="flex justify-center">
                            <div class="mx-auto">
                                <ui-photo [imageUrl]="file.path ?? ''" [id]="file.id" [size]="EComponentSize.Medium"
                                    [isCircular]="false" [editable]="false" [excludable]="false"
                                    (click)="openImage(file.path)"
                                    class="cursor-pointer group hover:scale-105 transition-transform duration-300">
                                </ui-photo>
                            </div>
                        </div>
                    </div>

                    <ng-template #emptyState>
                        <div class="flex flex-col items-center justify-center p-10 text-gray-500 dark:text-gray-400">
                            <ui-icon [icon]="EIcon.Image" [size]="EComponentSize.ExtraLarge"
                                [color]="EAlert.DARK"></ui-icon>
                            <p>Nenhuma foto disponível</p>
                        </div>
                    </ng-template>
                </div>

            </div>
        </div>

    </div>

    <ui-image-viewer *ngIf="imagePreview" [imageUrl]="imageUrlViewer"
        (close)="imagePreview = false; imageUrlViewer = ''">
    </ui-image-viewer>